// extracted by mini-css-extract-plugin
export var csatScore = "_j0-5";
export var header = "_j0-1";
export var panelWrapper = "_j0-2";
export var postPreview = "_j0-3";
export var rightContent = "_j0-0";
export var wrappingText = "_j0-4";